export const comEn = {
  'dat.common.actions': 'Actions',
  'dat.common.back': 'Back',
  'dat.common.clearFilters': 'Clear filters',
  'dat.common.close': 'Close',
  'dat.common.delete': 'Delete',
  'dat.common.discard': 'Discard changes',
  'dat.common.edit': 'Edit',
  'dat.common.save': 'Save changes',
  'dat.marc.title': 'MARC record',
  'dat.marc.none': 'This record has no MARC data.',
  'dat.err.generic': 'Something went wrong. Please try again.',
  'dat.err.AUTHORITY_EXISTS': 'An authority with this heading already exists for this type.',
  'dat.err.AUTHORITY_IN_USE': 'This authority is still linked to bibliographic records.',
  'dat.err.AUTHORITY_TYPE_MISMATCH': 'Only authorities of the same type can be merged.',
  'dat.err.AUTHORITY_TYPE_NOT_FOUND': 'That authority type no longer exists.',
  'dat.err.NOTHING_TO_MERGE': 'Select at least two authorities to merge.',
  'dat.err.INVALID_HEADING': 'This heading is not valid for the chosen authority type.',
  'dat.err.FILE_REQUIRED': 'Choose a file to import first.',
  'dat.err.INVALID_CSV': 'The CSV file could not be read. Check that it is UTF-8 with a header row.',
  'dat.err.INVALID_CSV_MAPPING': 'The column mapping is not valid. Map at least the title column.',
  'dat.err.CSV_TITLE_COLUMN_MISSING': 'Map one column to Title before staging the file.',
  'dat.err.NO_RECORDS': 'No records were found in this file. Check the format and try again.',
  'dat.err.BATCH_COMMITTED': 'This batch has already been imported.',
  'dat.err.BATCH_NOT_COMMITTED': 'This batch has not been imported, so there is nothing to revert.',
  'dat.err.BATCH_NOT_STAGED': 'This batch is no longer staged and cannot be changed.',
  'dat.err.BATCH_RUNNING': 'This batch is being imported right now. Wait for it to finish.',
  'dat.err.MATCH_RULE_EXISTS': 'A match rule with this code already exists.',
  'dat.err.MATCH_RULE_NOT_FOUND': 'That match rule no longer exists.',
  'dat.err.MATCH_RULE_REQUIRED': 'Choose a match rule to match records.',
  'dat.err.INVALID_MATCHPOINTS': 'One or more match points are not valid.',
  'dat.err.FRAMEWORK_NOT_FOUND': 'That framework code does not exist.',
  'dat.err.LIBRARY_NOT_FOUND': 'The default library no longer exists.',
  'dat.err.ITEM_TYPE_NOT_FOUND': 'The default item type no longer exists.',
  'dat.err.BIBLIO_NOT_FOUND': 'That catalogue record does not exist.',
  'dat.err.BIBLIO_IN_USE': 'That record has loans or holds and cannot be removed.',
  'dat.err.RECORD_IN_ERROR': 'This staged record has errors and cannot be imported.',
  'dat.err.REVERT_FAILED': 'Some records could not be reverted.',
} as const;

export const comHi: Record<keyof typeof comEn, string> = {
  'dat.common.actions': 'कार्रवाइयाँ',
  'dat.common.back': 'वापस',
  'dat.common.clearFilters': 'फ़िल्टर हटाएँ',
  'dat.common.close': 'बंद करें',
  'dat.common.delete': 'हटाएँ',
  'dat.common.discard': 'बदलाव छोड़ें',
  'dat.common.edit': 'संपादित करें',
  'dat.common.save': 'बदलाव सहेजें',
  'dat.marc.title': 'MARC रिकॉर्ड',
  'dat.marc.none': 'इस रिकॉर्ड में MARC डेटा नहीं है।',
  'dat.err.generic': 'कुछ गड़बड़ हो गई। कृपया फिर कोशिश करें।',
  'dat.err.AUTHORITY_EXISTS': 'इस प्रकार के लिए यह शीर्षक पहले से मौजूद है।',
  'dat.err.AUTHORITY_IN_USE': 'यह प्राधिकार अभी भी ग्रंथसूची रिकॉर्ड से जुड़ा है।',
  'dat.err.AUTHORITY_TYPE_MISMATCH': 'केवल एक ही प्रकार के प्राधिकार मर्ज किए जा सकते हैं।',
  'dat.err.AUTHORITY_TYPE_NOT_FOUND': 'वह प्राधिकार प्रकार अब मौजूद नहीं है।',
  'dat.err.NOTHING_TO_MERGE': 'मर्ज करने के लिए कम से कम दो प्राधिकार चुनें।',
  'dat.err.INVALID_HEADING': 'चुने गए प्राधिकार प्रकार के लिए यह शीर्षक मान्य नहीं है।',
  'dat.err.FILE_REQUIRED': 'पहले आयात के लिए फ़ाइल चुनें।',
  'dat.err.INVALID_CSV': 'CSV फ़ाइल पढ़ी नहीं जा सकी। जाँचें कि यह हेडर पंक्ति वाली UTF-8 फ़ाइल है।',
  'dat.err.INVALID_CSV_MAPPING': 'कॉलम मैपिंग मान्य नहीं है। कम से कम शीर्षक कॉलम मैप करें।',
  'dat.err.CSV_TITLE_COLUMN_MISSING': 'फ़ाइल स्टेज करने से पहले किसी कॉलम को शीर्षक से मैप करें।',
  'dat.err.NO_RECORDS': 'इस फ़ाइल में कोई रिकॉर्ड नहीं मिला। प्रारूप जाँचकर फिर कोशिश करें।',
  'dat.err.BATCH_COMMITTED': 'यह बैच पहले ही आयात हो चुका है।',
  'dat.err.BATCH_NOT_COMMITTED': 'यह बैच आयात नहीं हुआ है, इसलिए वापस करने को कुछ नहीं है।',
  'dat.err.BATCH_NOT_STAGED': 'यह बैच अब स्टेज में नहीं है और बदला नहीं जा सकता।',
  'dat.err.BATCH_RUNNING': 'यह बैच अभी आयात हो रहा है। पूरा होने तक प्रतीक्षा करें।',
  'dat.err.MATCH_RULE_EXISTS': 'इस कोड वाला मिलान नियम पहले से मौजूद है।',
  'dat.err.MATCH_RULE_NOT_FOUND': 'वह मिलान नियम अब मौजूद नहीं है।',
  'dat.err.MATCH_RULE_REQUIRED': 'रिकॉर्ड मिलाने के लिए मिलान नियम चुनें।',
  'dat.err.INVALID_MATCHPOINTS': 'एक या अधिक मिलान बिंदु मान्य नहीं हैं।',
  'dat.err.FRAMEWORK_NOT_FOUND': 'यह फ़्रेमवर्क कोड मौजूद नहीं है।',
  'dat.err.LIBRARY_NOT_FOUND': 'डिफ़ॉल्ट पुस्तकालय अब मौजूद नहीं है।',
  'dat.err.ITEM_TYPE_NOT_FOUND': 'डिफ़ॉल्ट आइटम प्रकार अब मौजूद नहीं है।',
  'dat.err.BIBLIO_NOT_FOUND': 'वह सूची रिकॉर्ड मौजूद नहीं है।',
  'dat.err.BIBLIO_IN_USE': 'उस रिकॉर्ड पर ऋण या होल्ड हैं, इसलिए उसे हटाया नहीं जा सकता।',
  'dat.err.RECORD_IN_ERROR': 'इस स्टेज किए गए रिकॉर्ड में त्रुटियाँ हैं और इसे आयात नहीं किया जा सकता।',
  'dat.err.REVERT_FAILED': 'कुछ रिकॉर्ड वापस नहीं किए जा सके।',
};
